import { ACTIVE_USERS_LIST_TAG } from '@/api';
import { api } from '@/api';
import { UserRoleType } from '@/api';
import { handleQueryLifecycle } from '../utils';

export type UserAddResponse = {
  userId: string;
};

type UserAddProps = {
  fullName: string;
  emailAddress: string;
  userRole: UserRoleType;
  teamId: string;
};

const userAddApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postUserAdd: builder.query<UserAddResponse, UserAddProps>({
      query: ({ fullName, emailAddress, userRole, teamId }: UserAddProps) => ({
        url: 'users/add',
        method: 'POST',
        body: {
          name: fullName,
          greeting: fullName.trim().split(/\s+/)[0] ?? '',
          user_role: userRole,
          email_address: emailAddress,
          team_id: teamId,
        },
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        await handleQueryLifecycle(queryFulfilled, () => {
          dispatch(api.util.invalidateTags([ACTIVE_USERS_LIST_TAG]));
        });
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useLazyPostUserAddQuery } = userAddApi;
